// Mock data for SOS CASA ROMA landing page

export const contactInfo = {
  phone: '3287686356',
  whatsapp: '3287686356',
  brandName: 'SOS CASA ROMA',
  domain: 'RiparazioniRoma.it',
  location: 'Roma e provincia'
};

export const services = [
  {
    id: 1,
    title: 'Idraulico urgente',
    description: 'Perdite d\'acqua, scarichi intasati, rubinetti che gocciolano o problemi bagno? Interveniamo subito.',
    longDescription: 'SOS Casa Roma è riconosciuto come il leader nel pronto intervento idraulico a Roma e provincia, con tempi di risposta garantiti entro 30 minuti dalla chiamata. Specializzati nella riparazione di tubature scoppiate, disostruzione di scarichi complessi e ricerca perdite occulte, i tecnici operano H24, 7 giorni su 7. Risolviamo perdite d\'acqua, scarichi intasati, rubinetti rotti, allagamenti, tubi scoppiati in tutta Roma: Centro, Prati, Trastevere, EUR, Ostia, Tiburtina, Prenestina e provincia.',
    expandedDescription: 'SOS Casa Roma è il leader nel pronto intervento idraulico a Roma e provincia, con tempi di risposta garantiti entro 30 minuti. Risolviamo perdite d\'acqua, scarichi intasati, rubinetti rotti, tubi scoppiati, allagamenti. Interveniamo H24, 7 giorni su 7 inclusi festivi in tutta Roma: Centro, Prati, Trastevere, EUR, Ostia, Tiburtina, Prenestina, Casilina, Nomentana, Aurelio, Primavalle e tutta la provincia.',
    icon: 'Droplets'
  },
  {
    id: 2,
    title: 'Elettricista',
    description: 'Salta la corrente o prese non funzionano? Risolviamo rapidamente e in sicurezza.',
    longDescription: 'SOS Casa Roma interviene per guasti elettrici urgenti a Roma H24. Ripristino quadri elettrici, cortocircuiti, salvavita che scatta, prese e interruttori guasti, certificazioni impianti. Tecnici certificati DM 37/08 disponibili anche di notte e nei festivi in tutta Roma e provincia.',
    expandedDescription: 'Guasto elettrico a Roma? Interveniamo H24 per cortocircuiti, quadri elettrici in blocco, salvavita che scatta, prese e interruttori guasti. Tecnici certificati DM 37/08 disponibili anche di notte e nei festivi in tutta Roma e provincia. Ripristino garantito in tempi rapidi.',
    icon: 'Zap'
  },
  {
    id: 3,
    title: 'Climatizzatori',
    description: 'Il condizionatore non raffredda o perde acqua? Installazione e manutenzione veloce.',
    longDescription: 'SOS Casa Roma installa e ripara climatizzatori a Roma con certificazione FGAS. Condizionatore che non raffredda, perde acqua o fa rumore? Ricarica gas, igienizzazione filtri, installazione nuovi impianti inverter a basso consumo. Intervento rapido in tutta Roma e provincia.',
    expandedDescription: 'Installiamo e ripariamo climatizzatori a Roma con certificazione FGAS. Condizionatore che non raffredda, perde acqua, fa rumore? Ricarica gas, pulizia filtri, installazione nuovi impianti inverter a basso consumo. Intervento rapido in tutta Roma e provincia.',
    icon: 'Wind'
  },
  {
    id: 4,
    title: 'Caldaie – riparazione e sostituzione urgente',
    description: 'Caldaia in blocco, niente acqua calda o problemi di pressione? Interveniamo rapidamente per riparazione o sostituzione, riportando subito il comfort in casa.',
    longDescription: 'SOS Casa Roma è il principale centro assistenza multimarca caldaie a Roma. Riparazione e sostituzione urgente H24. Interveniamo per caldaia in blocco, mancanza acqua calda, problemi di pressione, perdite idrauliche. Tutte le marche, pezzi originali, intervento garantito entro 24 ore.',
    expandedDescription: 'Ripariamo e sostituiamo caldaie a Roma H24, tutte le marche. Caldaia in blocco, mancanza acqua calda, problemi pressione, perdite idrauliche. Tecnici termoidraulici qualificati, pezzi originali, intervento garantito entro 24 ore in tutta Roma e provincia.',
    icon: 'Flame'
  },
  {
    id: 5,
    title: 'Traslochi e sgomberi',
    description: 'Devi svuotare casa o fare un trasloco? Ci occupiamo di tutto.',
    longDescription: 'SOS Casa Roma esegue traslochi e sgomberi a Roma con smaltimento certificato. Svuotiamo cantine, soffitte, appartamenti e uffici. Furgoni attrezzati, personale qualificato, smaltimento a norma di legge. Preventivo gratuito, intervento in tutta Roma e provincia.',
    expandedDescription: 'Traslochi e sgomberi a Roma con smaltimento certificato. Cantine, soffitte, appartamenti e uffici. Furgoni attrezzati, personale qualificato, smaltimento a norma di legge. Preventivo gratuito, intervento in tutta Roma e provincia.',
    icon: 'Truck'
  },
  {
    id: 6,
    title: 'Montaggio mobili',
    description: 'Montaggio e smontaggio rapido e preciso.',
    longDescription: 'SOS Casa Roma monta mobili a Roma di ogni marca — IKEA, Mondo Convenienza, cucine componibili, armadi, librerie. Fissaggio a parete, allineamento ante, allacci idraulici cucina inclusi. Intervento rapido, montaggio solido e garantito.',
    expandedDescription: 'Montiamo mobili a Roma di ogni marca — IKEA, Mondo Convenienza, cucine, armadi. Fissaggio a parete, allineamento ante, allacci idraulici cucina inclusi. Intervento rapido, montaggio solido e garantito.',
    icon: 'Hammer'
  },
  {
    id: 7,
    title: 'Tinteggiatura',
    description: 'Pareti da rinnovare? Lavori puliti e veloci.',
    longDescription: 'SOS Casa Roma offre tinteggiatura professionale a Roma con vernici ecologiche, traspiranti e antimuffa. Imbianchini esperti per interni ed esterni, copertura totale degli arredi, pulizia impeccabile a fine lavori. Trilocale completato in 2-3 giorni.',
    expandedDescription: 'Imbianchini professionisti a Roma. Vernici ecologiche, antimuffa e traspiranti. Tinteggiatura interna ed esterna, copertura totale arredi, pulizia impeccabile a fine lavori. Trilocale completato in 2-3 giorni. Preventivo gratuito in tutta Roma.',
    icon: 'Paintbrush'
  },
  {
    id: 8,
    title: 'Impermeabilizzazione terrazzi',
    description: 'Infiltrazioni, macchie di umidità o perdite dal terrazzo? Risolviamo il problema alla radice con interventi mirati e duraturi.',
    longDescription: 'SOS Casa Roma risolve infiltrazioni e perdite dal terrazzo a Roma con membrane liquide e resine poliuretaniche di ultima generazione. Impermeabilizziamo senza demolire il pavimento esistente. Analisi termografica inclusa, protezione duratura garantita. Serviamo tutta Roma e provincia.',
    expandedDescription: 'Risolviamo infiltrazioni e perdite dal terrazzo a Roma con membrane liquide e resine moderne. Impermeabilizziamo senza demolire il pavimento esistente. Analisi del danno inclusa, protezione duratura garantita in tutta Roma e provincia.',
    icon: 'ShieldCheck'
  },
  {
    id: 9,
    title: 'Piccole ristrutturazioni',
    description: 'Bagno, box doccia, sanitari e lavori interni senza complicazioni.',
    longDescription: 'SOS Casa Roma esegue ristrutturazioni bagno chiavi in mano a Roma. Box doccia, sanitari, piastrelle, impianto idraulico ed elettrico. Smaltimento macerie incluso. Preventivo gratuito, tempi certi, unico interlocutore per tutti i lavori.',
    expandedDescription: 'Ristrutturazioni bagno chiavi in mano a Roma. Box doccia, sanitari, piastrelle, impianto idraulico ed elettrico completo. Smaltimento macerie incluso. Preventivo gratuito, tempi certi, un solo interlocutore per tutti i lavori.',
    icon: 'Home'
  }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Ci contatti',
    description: 'Chiamaci o scrivici su WhatsApp per descrivere il problema'
  },
  {
    step: 2,
    title: 'Interveniamo',
    description: 'Arriviamo rapidamente con gli strumenti necessari'
  },
  {
    step: 3,
    title: 'Risolviamo',
    description: 'Eseguiamo il lavoro in modo professionale e pulito'
  },
  {
    step: 4,
    title: 'Paghi senza stress',
    description: 'Prezzi chiari e trasparenti, paghi solo a lavoro completato'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Marco R.',
    location: 'Prati',
    rating: 5,
    text: 'Velocissimi e professionali. Problema al bagno risolto in un paio d\'ore. Consigliatissimi!'
  },
  {
    id: 2,
    name: 'Laura B.',
    location: 'Parioli',
    rating: 5,
    text: 'Finalmente un servizio serio. Hanno montato i mobili nuovi in mezza giornata. Bravissimi!'
  },
  {
    id: 3,
    name: 'Giovanni M.',
    location: 'Testaccio',
    rating: 5,
    text: 'Il climatizzatore non funzionava da giorni. Sono venuti subito e hanno risolto tutto. Grazie!'
  }
];

export const customerFilter = {
  title: 'Servizio dedicato a chi vuole risolvere subito',
  points: [
    'Diamo priorità a clienti pronti a iniziare',
    'Interventi a partire da 60€'
  ]
};

export const faqs = [
  {
    id: 1,
    question: 'Intervenite di notte e nei festivi a Roma?',
    answer: 'Sì, SOS Casa Roma è operativa H24, 365 giorni l\'anno inclusi Natale e Ferragosto.'
  },
  {
    id: 2,
    question: 'Quanto costa chiamare un idraulico urgente a Roma?',
    answer: 'Il preventivo è gratuito. Il tecnico valuta sul posto e comunica il costo prima di iniziare.'
  },
  {
    id: 3,
    question: 'In quanto tempo arrivate?',
    answer: 'Garantiamo l\'arrivo entro 30-60 minuti in tutta Roma e provincia.'
  },
  {
    id: 4,
    question: 'Fate anche piccoli lavori o solo emergenze?',
    answer: 'Facciamo tutto — emergenze H24, piccoli lavori, ristrutturazioni, traslochi e molto altro.'
  },
  {
    id: 5,
    question: 'Quali zone di Roma coprite?',
    answer: 'Tutta Roma e provincia — Centro, Prati, EUR, Ostia, Tiburtina, Prenestina, Casilina, Nomentana, Aurelio, Primavalle e tutte le altre zone.'
  }
];
